module.exports = __webpack_public_path__ + "media/src/images/lv3Heading_background-de68070e16f6890c6ebc6e95a49d497d.png";